var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"items-container text-center px-3 pt-3 pb-2 rounded-xl",attrs:{"outlined":""}},[_c('div',{staticClass:"text-caption labelized noselect d-flex"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }